const introData = [
  {
    introText: `Welcome to this\nlearning module on`,
    titre: `Sales Growth Analysis`,
    subtitle:
      "Discover the algorithms and calculations behind the analysis, making it more transparent. ",
    buttonLabel: "LET'S START!",
  },
];

export default introData;
